import React from 'react';
import { Stack } from '@mui/material';
import { formatCurrency } from 'utils';

import { FieldChange } from './FieldChange';
import { ApprovalTermsChanges } from '../../../types';

const formatRate = (value: number | null): string => {
  if (value === null || value === undefined) return '—';
  return `${value}%`;
};

interface ApprovalTermsRenderProps {
  changes: ApprovalTermsChanges;
}

export const ApprovalTermsRender = ({ changes }: ApprovalTermsRenderProps) => (
  <Stack gap="0.25rem">
    {changes.approved_amount && (
      <FieldChange
        label="Approved Amount"
        before={changes.approved_amount.before ? formatCurrency(changes.approved_amount.before, true) : '—'}
        after={changes.approved_amount.after ? formatCurrency(changes.approved_amount.after, true) : '—'}
      />
    )}

    {changes.approved_rate && (
      <FieldChange
        label="Approved Rate"
        before={formatRate(changes.approved_rate.before)}
        after={formatRate(changes.approved_rate.after)}
      />
    )}

    {changes.buyrate_prequal && (
      <FieldChange
        label="Buy Rate Prequal"
        before={formatRate(changes.buyrate_prequal.before)}
        after={formatRate(changes.buyrate_prequal.after)}
      />
    )}

    {changes.approval_terms && (
      <FieldChange
        label="Approval Terms"
        before={JSON.stringify(changes.approval_terms.before) ?? '—'}
        after={JSON.stringify(changes.approval_terms.after) ?? '—'}
      />
    )}
  </Stack>
);
